import { LangCode, LanguageCode } from '../common/api-response.model';
import { Pager } from '../common/pagination.model';

// Old

export interface TagsResponse extends Pager {
  tags: TagInfoResponse[];
  records?: TagInfoResponse[];
}

export interface OneTagResponse {
  user_gradientcolor?: boolean;
  show_in_home?: boolean;
  tag_translations?: any;
  icon_image_url?: string;
  gradient_color_1?: string;
  slug?: string;
  tag: TagInfoResponse;
}

export interface TagInfoResponse {
  id: number;
  date: Date;
  slug:string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  user_gradientcolor:boolean
  translations: {
    id: number;
    lang_code: LangCode;
    tag_name: string;
    date: Date;
  }[];
  translation:{
    __key:string,
    language:string,
    name:string
  }
}

// Refactored

export interface PaginatedTags extends Pager {
  records: Tag[];
}



export interface Tag {
  id: number;
  cached_product_count: number;
  gradient_color_1: string;
  gradient_color_2: string;
  show_in_home: boolean;
  slug: string;
  translation: TagTranslation;
  tag_translations?:TagTranslation,
  createdAt?: string;
  updatedAt?: string;
  icon_image_url: string;
  use_gradient_colors?: boolean;
  show_banner_image?: boolean;
}

export interface TagTranslation {
  tag_id: number;
  language: LanguageCode
  name: string;
}


